import styled from 'styled-components';

/* ----------------------------------
   Final CTA
----------------------------------- */

export const FinalCTA = styled.section`
  width: 100%;

  padding: var(--space-xxl);

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-xxl);

  border-radius: var(--borderRadiusLarge);

  background: linear-gradient(135deg, var(--grey7) 0%, var(--black) 100%);

  box-shadow: var(--shadow-lg);

  @media screen and (max-width: 850px) {
    align-items: flex-start;
    flex-direction: column;
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-xl);
  }
`;

export const FinalCTAContent = styled.div`
  max-width: 690px;

  h2 {
    margin: var(--space-xs) 0 var(--space-m);

    color: var(--white);

    font-size: clamp(1.8rem, 3vw, 2.7rem);
    line-height: 1.05;
    font-weight: 900;
  }

  > p:not(.eyebrowHeader) {
    margin: 0;

    color: var(--grey2);

    font-size: 0.95rem;
    line-height: 1.75;
  }
`;

export const FinalCTAActions = styled.div`
  flex-shrink: 0;

  display: flex;
  flex-direction: column;
  gap: var(--space-s);

  @media screen and (max-width: 850px) {
    width: 100%;
  }
`;
